<form fxLayout="column" name="itinerary-day-info-form">
  <mat-form-field appearance="outline">
    <mat-label>Titolo giorno {{ dayId + 1 }}</mat-label>
    <input name="title" matInput [(ngModel)]="day.title" type="text" required />
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>Descrizione giorno {{ dayId + 1 }}</mat-label>
    <textarea
      rows="5"
      name="description"
      matInput
      [(ngModel)]="day.description"
      required
    ></textarea>
    <app-inline-help-button
      matSuffix
      [title]="'Descrizione giorno'"
      [content]="
        'Scrivi in modo descrittivo (NON con elenchi puntati) e sintetico cosa si andrà a fare/vedere durante questo giorno. Non importa citare tutti i punti di interesse che il cliente vedrà ma basta una cosa molto generica ed accattivante come: “oggi ti godrai il centro storico e la città vecchia così da fare un passo indietro nella storia della città”.\n\nAttenzione a non eccedere lo spazio disponibile nell’itinerario, utilizza la funzione “Anteprima” per controllare.'
      "
    >
    </app-inline-help-button>
  </mat-form-field>
</form>
